import { createContext, useContext } from "react";
import type { GTM } from "@bmi-digital/components/types";

export type OnAnalyticsEvent = (event: GTM) => void;

export const AnalyticsContext = createContext<OnAnalyticsEvent>(() => {
  // no-op
});

export const useAnalyticsContext = () => useContext(AnalyticsContext);
